import axios from 'axios'
import store from "@/store/store";
/* global localStorage */

const http = axios.create({
  baseURL: process.env.VUE_APP_API_URL,
  headers: {
    'Content-Type': 'application/json',
    'X-App-Lang' : store.state.lang
  }
})

if (localStorage.getItem('access_token')) {
  http.defaults.headers.common['Authorization'] = 'Bearer ' + localStorage.getItem('access_token')
}

export default http
